// extracted by mini-css-extract-plugin
export var partner = "partners-module--partner--1zzb9";
export var partnerTitle = "partners-module--partnerTitle--3e4eP";
export var logo = "partners-module--logo--2lgRp";
export var logoItem = "partners-module--logoItem--356n-";
export var staticImage = "partners-module--staticImage--2beAP";